<div></div>

<script>
  import {Pie} from 'vue-chartjs'

  export default {
    extends: Pie,
    props: {
      menu: {
        type: Array
      }
    },
    mounted () {
      const chartData = {}
      const options = {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        }
      }

      let menu = []
      let jumlah = []
      let color = []

      this.menu.forEach((item) => {
        menu.push(item.menu)
        jumlah.push(item.jumlah)
        color.push('#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'))
      })

      chartData.labels = menu
      chartData.datasets = {
        backgroundColor: color,
        data: jumlah
      }

      const cd = {
        labels: menu,
        datasets: [
          {
            label: 'Data One',
            backgroundColor: color,
            data: jumlah
          }
        ]
      }

      this.renderChart(cd, options)
    }
  }
</script>

<style>
  canvas {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PieChart.vue